import React, { useState } from 'react';
import GetAllFormationController from '../../Controller/GetAllFormationController';
import { useNavigate } from 'react-router-dom';

const SelectButton = (option) => {
  const [selectedOption, setSelectedOption] = useState(option.option);
  const navigate = useNavigate();

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
    console.log(`Option sélectionnée : ${event.target.value}`);
    handleNavigate(event.target.value);
  };

  const handleNavigate = (value) => {
    navigate("/formations/"+value);
    window.location.reload();

}

  return (
    <div>
      <label htmlFor="select">Choisissez une option : </label>
      <select id="select" className='filter-button' value={selectedOption} onChange={handleChange}>
        <option value="">Type</option>
        <option value="incendie">Incendie</option>
        <option value="secourisme">Secourisme</option>
        <option value="prevention">Prévention</option>
      </select>
    </div>
  );
};

export default SelectButton;